import SEO from '../../components/base/SEO';
import Header from './components/Header';
import Hero from './components/Hero';
import BasicSpecs from './components/BasicSpecs';
import Merits from './components/Merits';
import SpeedGuide from './components/SpeedGuide';
import Demerits from './components/Demerits';
import Reviews from './components/Reviews';
import SuitableFor from './components/SuitableFor';
import HowToApply from './components/HowToApply';
import CTASection from './components/CTASection';
import Footer from './components/Footer';
import Breadcrumb from '../../components/feature/Breadcrumb';

export default function SurugaCard() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "FinancialProduct",
    "name": "地方銀行系スピード発行カード",
    "description": "即日発行に対応した地方銀行系クレジットカード。スピード発行で最短当日から利用可能。スマホアプリで即時カード番号を発行し、すぐに使えます。",
    "brand": {
      "@type": "Brand",
      "name": "地方銀行系スピード発行カード"
    },
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "JPY",
      "availability": "https://schema.org/InStock"
    },
    "url": `${siteUrl}/suruga`
  };

  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="地方銀行系スピード発行カード詳細｜即日発行クレジットカード比較ナビ"
        description="即日発行に対応した地方銀行系クレジットカードの詳細情報。アプリで即時カード番号発行、スマホ決済にもすぐ対応。スペック・メリット・デメリット・口コミを徹底解説します。"
        keywords="即日発行,スピード発行,地方銀行系カード,クレジットカード,当日使える,アプリ発行"
        canonical="/suruga"
        structuredData={structuredData}
      />
      <Header />
      <Breadcrumb items={[
        { label: 'ホーム', path: '/' },
        { label: 'カード詳細', path: '/ranking' },
        { label: '地方銀行系スピード発行カード' }
      ]} />
      <Hero />
      <CTASection />
      <BasicSpecs />
      <Merits />
      <SpeedGuide />
      <Demerits />
      <CTASection />
      <Reviews />
      <SuitableFor />
      <HowToApply />
      <CTASection />
      <Footer />
    </div>
  );
}
